import React, { Component } from 'react'
import { fromJS } from 'immutable'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form/immutable'
import FormModal from 'bisu-react-modal'

import FormChangeSection from './form-change-section'
import {
  getSimilarSubjects,
  changeSection,
  changeSectionRevert,
} from './-actions'

const withChangeSection = WrappedComponent =>
  connect()(
    class extends Component {
      constructor(props) {
        super(props)
        this.state = {
          openModal: false,
          withPending: 0,
          itemID: 0,
        }
      }

      _openModal = item => {
        this.props.dispatch(getSimilarSubjects(item.get('offering_subject_id')))
        this.setState({
          openModal: true,
          itemID: item.get('offering_subject_id'),
          withPending: item.getIn(['to', 'offering_subject_id']),
        })
      }

      _closeModal = () => {
        this.setState({
          openModal: false,
        })
      }

      _onSubmit = itemto => {
        this.props
          .dispatch(
            changeSection(this.state.itemID, itemto.get('offering_subject_id')),
          )
          .then(res => {
            if (!res.error) {
              this._changeCORState(res.payload)
            }
          })
      }

      _onRevert = () => {
        this.props
          .dispatch(changeSectionRevert(this.state.withPending))
          .then(res => {
            if (!res.error) {
              this._changeCORState(res.payload)
            }
          })
      }

      _changeCORState = state => {
        this.props.dispatch(actions.change('corState', fromJS(state || {})))
        this.setState({
          openModal: false,
          withPending: 0,
          itemID: 0,
        })
      }

      _renderModal() {
        const { openModal, withPending, itemID } = this.state
        const { __pending } = this.props

        return (
          <FormModal
            onClose={this._closeModal}
            isOpen={openModal}
            className="modal-lg"
            draggable
            withClose
          >
            <FormChangeSection
              itemID={itemID}
              isEdit={!!withPending}
              onSubmit={this._onSubmit}
              onRevert={this._onRevert}
              pending={__pending}
            />
          </FormModal>
        )
      }

      render() {
        return (
          <div>
            <WrappedComponent
              openChangeSection={this._openModal}
              {...this.props}
            />
            {this._renderModal()}
          </div>
        )
      }
    },
  )
export default withChangeSection



// WEBPACK FOOTER //
// ./src/containers/COR/hocs/withChangeSection/index.js